// extracted by mini-css-extract-plugin
export default {"wrapper":"LeadBucket_wrapper__Or-CN"};